import { requestFlowActionsRegex } from "../constants/apiLoading";
/**
 * Get the name of the call being made.
 * Replace /(_REQUEST|_SUCCESS|_FAILURE)$/ with empty string
 *
 * @param {string} action
 * @returns {string}
 */ export function getCall(action) {
    return action.replace(requestFlowActionsRegex, "");
}
export default {
    getCall: getCall
};

//# sourceMappingURL=apiLoading.js.map